import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { Avatar, Title, Button, Card } from 'components'
import { useSocket, useStateValue } from 'providers'
import { Question } from '../components'
import { useQueue, useJoinQueue } from 'hooks'

const Players = styled.div`
  width: 100%;
  margin 1.25rem 0;
  display: flex;
`

const Game = styled.div`
  ${({ theme: { colors } }) => `
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    background: ${colors('chrome')};
    z-index: 99;
  `}
`

const TriviaState = ({ game }) => {
  if (game.state === 'pending') {
    return <Title level="3">Please stand by.</Title>
  }
  if (game.state === 'active') {
    return (
      <Game>
        <Question
          current={game?.QueueItems.find((q) => q.state === 'active')}
          allItems={game?.QueueItems}
        />
      </Game>
    )
  }
  if (game.state === 'completed') {
    return <Title level="3">Game Over! Thanks for playing.</Title>
  }
  return <Title level="3">This game is no longer available.</Title>
}

export const TriviaShow = () => {
  const [currentPlayer, setPlayer] = useState()
  const { id } = useParams()

  const socket = useSocket()

  const [{ queues, session: { user } }, dispatch] = useStateValue()
  const { queue } = useQueue({ id })
  const { joinQueue } = useJoinQueue()

  useEffect(() => {
    if (!queue) return
    dispatch({ type: 'GET_QUEUE_SUCCESS', data: queue })
  }, [queue])

  // Socket events already provide updated data via UPDATE_QUEUE_SUCCESS
  // No need to refetch on update

  useEffect(() => {
    const inQueue = queues?.show?.players.find((p) => p.id === user.id)
    setPlayer(inQueue)
  }, [queues?.show])

  // Use the queue's slug for socket channel (API emits using slug, not UUID)
  const slug = queues?.show?.slug
  useEffect(() => {
    if (!slug) return
    const channel = `/trivia/${slug}`
    const handleSocketEvent = (res) => {
      dispatch(res)
    }
    socket.on(channel, handleSocketEvent)
    return () => socket.off(channel, handleSocketEvent)
  }, [socket, slug, dispatch])

  const join = () => {
    joinQueue(queues?.show.id, { user_id: user.id }).then((res) => {
      dispatch(res)
      socket.emit(`/trivia/${queues.show.slug}`, {
        action: 'USER_JOINED',
        user
      })
    })
  }

  if (!queues?.show) return null
  return (
    <Card padding="1rem">
      <Title level="2">Trivia</Title>
      <Players>
        {queues?.show?.players.map((player) => (
          <Avatar key={player.id}>{player.email}</Avatar>
        ))}
      </Players>
      {!currentPlayer && <Button onPress={join}>Join</Button>}
      {queues?.show?.players.find((p) => p.id === user.id)
        ? (
        <TriviaState game={queues?.show} />
          )
        : null}
    </Card>
  )
}
